import {call, put, takeLatest} from "redux-saga/effects";
import {
    FETCH_REGIONS_REQUEST,
    fetchRegionsSuccess,
    fetchRegionsFailure,
    fetchHcpTypeSuccess,
    fetchHcpTypeFailure,
    FETCH_HCP_TYPES_REQUEST,
    getSpecialitiesSuccess,
    getSpecialitiesFailure,
    GET_SPECIALITIES_REQUEST, setFacilityDocuments, GET_FACILITY_DOCUMENTS,
    fetchCustomersConfigSuccess, fetchCustomersConfigFailure, FETCH_CUSTOMERS_CONFIG_REQUEST
} from "../actions/meta.action";
import CommonService from "../../helpers/common-service";
import {ENV} from "../../constants";


function* fetchAndSetFacilityDocuments(action: any): any {
    try {
        const facilityId = action?.facilityId;
        // if (!facilityId) {
        //     console.error("Facility ID is missing in the action.");
        //     return;
        // }

        // Construct the API URL with the query parameter
        const apiUrl = `${ENV.API_URL}facility/documentsList?is_default=${facilityId}`;
        console.log("Fetching from API:", apiUrl); // Debugging log

        // Fetch the documents
        // @ts-ignore
        const response = yield call(CommonService._api.get, apiUrl);
        console.log("API Response:", response);

        // Dispatch the action to set the documents in Redux store
        yield put(setFacilityDocuments(response.data || []));
    } catch (error) {
        console.error("Error fetching facility documents:", error);
        // Handle error appropriately, e.g., dispatch an error action if needed
        // yield put(fetchRegionsFailure(error));
    }
}


function fetchRegions(): any {
    return CommonService._api.get(ENV.API_URL + `regions`);
}

function* getRegionsList() {
    try {
        // @ts-ignore
        const response = yield call(fetchRegions);
        yield put(fetchRegionsSuccess(response.data || []));
    } catch (error) {
        yield put(fetchRegionsFailure(error));
    }
}

function fetchHcpTypes(): any {
    return CommonService._api.get(ENV.API_URL + `meta/staffTypes`);
}

function* getHcpTypeList() {
    try {
        // @ts-ignore
        const response = yield call(fetchHcpTypes);
        yield put(fetchHcpTypeSuccess(response?.data?.staffTypes || []));
    } catch (error) {
        yield put(fetchHcpTypeFailure(error));
    }
}

export function* getSpecialitiesSaga() {
    try {
        //@ts-ignore
        const response = yield call(CommonService._api.get, ENV.API_URL + "meta/staffSpecialities");
        yield put(getSpecialitiesSuccess(response.data?.specialities || []));
    } catch (error: any) {
        yield put(getSpecialitiesFailure(error.message));
    }
}

function fetchCustomersConfig(): any {
    return CommonService._api.post(ENV.API_URL + `customer/customerList`);
}

function* getCustomersConfig() {
    try {
        // @ts-ignore
        const response = yield call(fetchCustomersConfig);
        yield put(fetchCustomersConfigSuccess(response.data || []));
    } catch (error) {
        yield put(fetchCustomersConfigFailure(error));
    }
}


function* metaSaga() {
    yield takeLatest(FETCH_REGIONS_REQUEST, getRegionsList);
    yield takeLatest(FETCH_HCP_TYPES_REQUEST, getHcpTypeList);
    yield takeLatest(GET_SPECIALITIES_REQUEST, getSpecialitiesSaga);
    yield takeLatest(GET_FACILITY_DOCUMENTS, fetchAndSetFacilityDocuments);
    yield takeLatest(FETCH_CUSTOMERS_CONFIG_REQUEST, getCustomersConfig);
}

export default metaSaga;
